import { UserProfileType } from "./userprofiletype";
import { UserRestriction } from "./UserRestriction";
import { UserThemeType } from "./UserThemeType";
export class UserProfile{
    name : string = "";
    userProfileType: UserProfileType;
    userRestriction: UserRestriction;
    userThemeType: UserThemeType; 
}